import { WellSegmentModel, CasingTypeModel } from "./casing-plan.model";

export function booleanToYesNo(value: boolean): string {
    return (value) ? "Yes" : "No";
}

export function isDefined(value: any): boolean {
    return value !== undefined && value !== null;
}


export function isDefinedAndNotEmpty(property: any): boolean { 
    if (property === undefined || property === null) return false;
    return property.toString() !== "";
}


export function segmentHasData(model: WellSegmentModel): boolean {
    return model.casingType.code !== 'PKR' && (isDefinedAndNotEmpty(model.boreholeDiameter) || isDefinedAndNotEmpty(model.boreholeDepth) || isDefinedAndNotEmpty(model.casingDiameter) || isDefinedAndNotEmpty(model.casingLength) || isDefinedAndNotEmpty(model.cementTop) || isDefinedAndNotEmpty(model.cementVolume)
        || isDefinedAndNotEmpty(model.hasAngles) || (isDefinedAndNotEmpty(model.formation) && isDefinedAndNotEmpty(model.formation.code)) || (isDefinedAndNotEmpty(model.drillingEquipment) && isDefinedAndNotEmpty(model.drillingEquipment.code)) || isDefinedAndNotEmpty(model.numberCentralizers)
        || model.tested || model.produced || model.injected || model.hydraulicFracturing);
}

export function toCamel(o) {
        var newO, origKey, newKey, value;
        let returnArray = [];
        for (let i = 0; i < o.length; i++) {
            newO = {}
            for (origKey in o[i]) {
                if (o[i].hasOwnProperty(origKey)) {
                    newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                    value = o[i][origKey];
                    if (value instanceof Array || (value !== null && value.constructor === Object)) {
                        value = this.toCamel(value);
                    }
                    newO[newKey] = value;
                }
                //}
            }
            returnArray.push(newO);
        }
        return returnArray;
}

export function properCaseString(name: string): string {
    let result = "";
    for (let c = 0; c < name.length; c++) {
        let chr = name[c];
        if (c === 0) {
            chr = chr.toUpperCase();
            result = chr;
        } else if (chr === chr.toUpperCase()) {
            result = `${result} ${chr}`;
        } else {
            result = `${result}${chr}`;
        }
    }
    return result;
}


export function hasBorehole(segment: WellSegmentModel): boolean {
    return isDefined(segment.boreholeBottom) || isDefined(segment.boreholeTop) || (isDefined(segment.boreholeDiameter) && segment.boreholeDiameter.toString().trim() !== "");
}

export function hasCasing(segment: WellSegmentModel): boolean {
    return isDefined(segment.casingBottom) || isDefined(segment.casingTop) || (isDefined(segment.casingDiameter) && segment.casingDiameter.toString().trim() !== "");
}

export function hasCement(segment: WellSegmentModel): boolean {
    return isDefined(segment.cementVolume) || isDefined(segment.cementTop) || isDefined(segment.cementBottom);
}

export function typeTransformer(type: any): CasingTypeModel {
    if (!type.hasOwnProperty("definition") && type.hasOwnProperty("Definition")) {
        type.definition = type["Definition"];
        delete type.Definition;
    }
    if (!type.hasOwnProperty("code") && type.hasOwnProperty("Code")) {
        type.code = type["Code"];
        delete type.Code;
    }
    return type as CasingTypeModel;
}
